const routes = [
  // {
  //   path: "/financeManage",
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/financeManage/finance",
  //   meta: {
  //     hidden: true,
  //     needLogin: true,
  //     // title: process.env.VUE_APP_APPNAME,
  //     title: "财务",
  //   },
  //   children: [
  //     {
  //       path: "finance",
  //       name: authCodeMap.financeManage_finance,
  //       component: (): any => import("@/modules/financeManage/pages/index/newIndex.vue"),
  //       meta: {
  //         hidden: true,
  //         needLogin: true,
  //         title: "财务",
  //       },
  //     },
  //   ],
  // },
];
export default routes;